/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Files_Error_Causes_EmptyInputs */



/**
* | output |
* | --- |
* | "No failed files." |
*
* @param {Files_Error_Causes_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const files_error_causes_empty = /** @type {((inputs?: Files_Error_Causes_EmptyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Files_Error_Causes_EmptyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine fehlgeschlagenen Dateien.")
	return /** @type {LocalizedString} */ ("No failed files.")
});